<!--
  Dialog global "Sesion expirada".

  Se abre cuando el interceptor de api.js detecta un 401 con sesion activa
  (token vencido o TokenVersion bumpeado desde otra app del ecosistema).
  El usuario ve un mensaje claro y un boton para volver a iniciar sesion.
-->
<template>
  <v-dialog v-model="open" persistent max-width="420">
    <v-card>
      <v-card-title class="d-flex align-center gap-2">
        <v-icon color="warning">mdi-clock-alert-outline</v-icon>
        <span>Sesion expirada</span>
      </v-card-title>
      <v-card-text class="text-body-2">
        Tu sesion vencio o fue cerrada desde otra app. Vuelve a iniciar sesion para continuar.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          variant="flat"
          :loading="working"
          prepend-icon="mdi-login"
          @click="handleRelogin"
        >
          Volver a iniciar sesion
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { subscribeSessionExpired } from '@/services/sessionExpired'

const HUB_URL = process.env.VUE_APP_HUB_URL || ''

export default {
  name: 'SessionExpiredDialog',
  setup() {
    const store = useStore()
    const open = ref(false)
    const working = ref(false)
    let unsubscribe = null

    onMounted(() => {
      unsubscribe = subscribeSessionExpired(() => {
        open.value = true
      })
    })

    onUnmounted(() => {
      if (unsubscribe) unsubscribe()
    })

    const handleRelogin = async () => {
      working.value = true
      try {
        await store.dispatch('auth/logout')
      } finally {
        // Si esta configurado HUB_URL, mandamos al SSO del Hub (entornos UAT/Prod);
        // si no, al login propio (dev local sin Hub).
        window.location.replace(HUB_URL ? `${HUB_URL}/login` : '/login')
      }
    }

    return { open, working, handleRelogin }
  }
}
</script>
